import React, { useEffect, useState } from 'react';
import ConfirmModal from '../../../../src/components/ConfirmModal';
import type { AvisoUc } from '../../../../src/lib/avisosUc';

const MOTIVO_MINIMO = 5;

interface Props {
    aviso: AvisoUc | null;
    salvando: boolean;
    onCancelar: () => void;
    onConfirmar: (motivo: string) => void;
}

// Encerrar tira o aviso de todas as faturas daqui para frente — diferente do "Ciente
// neste mês", que só registra que ele foi aplicado na fatura aberta.
const EncerrarAvisoModal: React.FC<Props> = ({ aviso, salvando, onCancelar, onConfirmar }) => {
    const [motivo, setMotivo] = useState('');
    useEffect(() => { setMotivo(''); }, [aviso?.id]);
    const valido = motivo.trim().length >= MOTIVO_MINIMO;

    return (
        <ConfirmModal
            isOpen={!!aviso}
            onClose={() => { if (!salvando) onCancelar(); }}
            onConfirm={() => { if (valido) onConfirmar(motivo); }}
            title="Encerrar aviso"
            message="O aviso deixa de aparecer em todas as próximas faturas desta UC. Para registrar só que você aplicou nesta fatura, use “Ciente neste mês”."
            confirmLabel="Encerrar aviso"
            variant="danger"
            loading={salvando}
            confirmDisabled={!valido}
        >
            <label className="block text-xs font-bold text-gray-600 dark:text-gray-300 uppercase mb-1" htmlFor="motivo-encerrar-aviso">Motivo</label>
            <textarea
                id="motivo-encerrar-aviso"
                value={motivo}
                onChange={e => setMotivo(e.target.value)}
                rows={3}
                placeholder="Ex.: desconto passou para o cadastro da UC; cliente cancelou; já resolvido."
                className="w-full p-3 border border-gray-200 dark:border-gray-700 rounded-xl bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary/20 outline-none resize-none"
            />
        </ConfirmModal>
    );
};

export default EncerrarAvisoModal;
